import { Injectable } from '@angular/core';

import { SpinnerService } from 'dspx-core';

import { SpinnerSelector, SpinnerDisplayTimeoutMs } from '../constants/app-data.constants'

import { Thread } from '../helpers/thread';

import { HtmlHelperService } from './html-helper.service'

@Injectable({
  providedIn: 'root'
})
export class CustomSpinnerService {

  private static readonly Selector = SpinnerSelector;
  private static readonly DisplayTimeoutMs = SpinnerDisplayTimeoutMs;
  private static readonly MaxHideAttempts = 100;
  private static readonly DoEventsWaitMs = 10;
  private static readonly DefaultMessage = 'Please wait';

  constructor(
    private spinnerService: SpinnerService,
    private htmlHelperService: HtmlHelperService) {
  }

  async ensureSpinnerIsVisible(): Promise<void> {

    const isSpinnerVisible = this.htmlHelperService.isSpinnerVisible(CustomSpinnerService.Selector);
    if (!isSpinnerVisible) {
      this.spinnerService.showSpinner();
      await Thread.sleep(1.5 * CustomSpinnerService.DisplayTimeoutMs);
    }
  }

  async hideAllSpinners(): Promise<void> {

    let activeSpinners = this.spinnerService.hideSpinner();
    let attemptCount = 0;
    while (activeSpinners > 0 && attemptCount < CustomSpinnerService.MaxHideAttempts) {
      await Thread.sleep(CustomSpinnerService.DoEventsWaitMs);
      activeSpinners = this.spinnerService.hideSpinner();
      attemptCount++;
    }
  }

  setSpinnerElementMessage(
    title: string = CustomSpinnerService.DefaultMessage,
    step?: string,
    subStep?: string): void {

    const htmlContent = this.getCustomSpinnerElementContent(title, step, subStep);
    this.htmlHelperService.setSpinnerElementContent(CustomSpinnerService.Selector, htmlContent);
  }

  // The original innerHTML of the spinner element provided by the DSPX framework is this:
  //     Please wait
  //     <div class="loading-icon">
  //         <span class="dot first"/>
  //         <span class="dot second"/>
  //         <span class="dot third"/>
  //         <span class="dot fourth"/>
  //         <span class="dot fifth"/>
  //     </div>
  // This method replaces the innerHTML above to allow the display of three different messages: title, step and subStep
  private getCustomSpinnerElementContent(
    title: string = CustomSpinnerService.DefaultMessage,
    step?: string,
    subStep?: string): string {

    const fiveDotsHtmlContent = `
      <div class="loading-icon">
        <span class="dot first"></span>
        <span class="dot second"></span>
        <span class="dot third"></span>
        <span class="dot fourth"></span>
        <span class="dot fifth"></span>
      </div>
    `;
    const titleHtmlContent = `<div class="spinner-title">${title}${fiveDotsHtmlContent}</div>`;

    const stepHtmlContent = step
      ? `<div class="spinner-step-message">${step}</div>`
      : ``;

    const subStepHtmlContent = subStep
      ? `<div class="spinner-sub-step-message">${subStep}</div>`
      : ``;

    const htmlContent = `
      <span class="spinner-wrapper">
        ${titleHtmlContent}
        ${stepHtmlContent}
        ${subStepHtmlContent}
      </span>`;

    return htmlContent;
  }
}
